<h1 mat-dialog-title> Anular/Reversar Cuota </h1> <br/>

<mat-dialog-content>

    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <mat-label> Motivo anulación o reversa </mat-label>

            <input matInput placeholder="Motivo anulación o reversa" [(ngModel)]="data.motivoAnulacion" required name="motivoAnulacion" id="motivoAnulacion">

        </mat-form-field>
    </p>

</mat-dialog-content>

<div mat-dialog-actions>

    <button mat-button class="mat-raised-button btn-danger" (click)="onAnularReversar()">
        <i class = "fa fa-times"> </i> Anular/Reversar
    </button>

    <button mat-button class="mat-raised-button btn-dark mat-button" (click)="onCancelarClick()"> 
        <i class = "fa fa-trash"> </i> Cancelar
    </button>

</div>